<template>
  <div class="mt-[12px]">
    <!-- 用户条件 -->
    <div v-if="configInfo.scope !== 'Unlimited' || showBox">
      <div
        v-if="showBox"
        class="bg-[#2C7952]/70 text-white text-[15px] pl-3 py-3 rounded-t-lg"
      >
        {{ $t('Activities.Redpackage.UserEffectiveConditions') }}
      </div>
      <div
        v-if="showBox && showBox !== 'HasDeposit'"
        class="bg-[#2C7952]/40 text-[11px] font-[500] text-white mt-[2px] flex-center py-[10px] px-2.5"
      >
        <span>{{
          configInfo.scope == "All"
            ? $t('Activities.Redpackage.MeetAllConditions')
            : $t('Activities.Redpackage.MeetAnyCondition')
        }}</span>
      </div>

      <div v-if="showBox && showBox !== 'HasDeposit'">
        <div
          class="text-[13px] font-[500] text-white mt-[2px] flex items-center gap-[2px]"
        >
          <div class="table-item bg-[#2C7952]/20">{{ $t('Activities.Redpackage.Deposits') }}</div>
          <div class="table-item bg-[#2C7952]/20">
            <span class="text-[13px]">{{
              formatter().format(configInfo?.depositAmount)
            }}</span
            >/
            <span class="text-[11px] text-white/65">{{
              formatter().format(configInfo.requireDeposit)
            }}</span>
          </div>
          <div class="table-item bg-[#2C7952]/20">
            <img
              v-if="Number(configInfo.depositAmount) >= Number(configInfo.requireDeposit)"
              :src="iChecked"
              class="size-5"
            />
            <div v-else class="table-item-checked" @click="$router.push('/deposito')">
              {{ $t('Activities.Redpackage.DepositAction') }}
            </div>
          </div>
        </div>
        <div
          class="text-[13px] font-[500] text-white mt-[2px] flex items-center gap-[2px]"
        >
          <div class="table-item bg-[#2C7952]/40">{{ $t('Activities.Redpackage.Bet') }}</div>
          <div class="table-item bg-[#2C7952]/40">
            <span class="text-[13px]">{{ formatter().format(configInfo.betAmount) }}</span
            >/
            <span class="text-[11px] text-white/65">{{
              formatter().format(configInfo.requireBet)
            }}</span>
          </div>
          <div class="table-item bg-[#2C7952]/40">
            <img
              v-if="Number(configInfo.betAmount) >= Number(configInfo.requireBet)"
              :src="iChecked"
              class="size-5"
            />
            <span v-else class="table-item-checked" @click="$router.push('/')"
              >{{ $t('Activities.Redpackage.BetAction') }}</span
            >
          </div>
        </div>
      </div>
      <div v-if="showBox && showBox == 'HasDeposit'">
        <div
          class="text-[13px] font-[500] text-white mt-[2px] flex items-center gap-[2px]"
        >
          <div class="table-item bg-[#2C7952]/20" style="flex-grow: 1">
            {{ $t('Activities.Redpackage.FirstDeposit') }}
          </div>
          <div class="table-item bg-[#2C7952]/20" style="flex-grow: 2">
            <img
              v-if="Number(configInfo.depositAmount) > 0"
              :src="iChecked"
              class="size-5"
            />
            <div v-else class="table-item-checked" @click="$router.push('/deposito')">
              {{ $t('Activities.Redpackage.DepositAction') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 获奖公告 -->
    <div class="mt-[12px]">
      <div
        class="bg-[#2C7952]/70 flex items-center gap-2 text-white text-[15px] pl-3 py-3 rounded-t-lg"
      >
        <img :src="topIcon" class="size-5" />
        {{ $t('Activities.Redpackage.WinnersAnnouncement') }}
      </div>

      <div ref="scrollContainer" class="overflow-hidden max-h-[150px]">
        <div
          v-for="(item, index) in awardDatas"
          :key="index"
          :class="[
            'text-[13px] font-[500] text-white mt-[2px] flex-center h-[52px] px-2.5',
            index % 2 === 0 ? 'bg-[#2C7952]/40' : 'bg-[#2C7952]/20',
          ]"
        >
          <img :src="iMoney" class="size-5" />
          <div class="flex-1 mx-4">
            <span class="text-[12px]">
              {{ $t('Activities.Redpackage.UserReceivedReward', { username: item.username }) }}
            </span>
          </div>
          <div class="min-w-[60px]">
            <span class="text-[16px] text-[#0BCF33]"> {{ item.amount }}</span>
            <span class="text-[10px]"> R$</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatter } from "@/utils";
import { ref } from "vue";
import { getRedPackageAwardData } from "@/api/redpackage";
import iChecked from "@a/assets/images/i_checked2.png";
import topIcon from "./../images/topIcon.png";
import iMoney from "@a/assets/images/i_money2.png";
import { useRoute } from "vue-router";
const activityId: any = useRoute().query.activityId || "";
const scrollContainer = ref<HTMLElement | null>(null);
const scrollInterval = ref<any>(null);
const scrollSpeed = 3; // 滚动速度，可以调整
const { configInfo } = defineProps<{
  configInfo?: any;
}>();
const awardDatas = ref<any>([]);
const autoScroll = () => {
  if (scrollContainer.value) {
    const { scrollTop, clientHeight, scrollHeight } = scrollContainer.value;

    if (scrollTop >= scrollHeight - clientHeight) {
      scrollContainer.value.scrollTop = 0;
    } else {
      scrollContainer.value.scrollTop += scrollSpeed;
    }
  }
};

const getRedPackageAward = async () => {
  const { code, data } = await getRedPackageAwardData({
    activityId,
  });
  if (code === 1) {
    awardDatas.value = data;
  }
};
onMounted(() => {
  getRedPackageAward();
  if (scrollContainer.value) {
    scrollInterval.value = setInterval(autoScroll, 100); // 每 100 毫秒滚动一次
  }
});

onUnmounted(() => {
  if (scrollInterval.value) {
    clearInterval(scrollInterval.value); // 组件卸载时清除定时器
  }
});

const showBox: any = computed(() => {
  const { scope, betAmount, requireBet, depositAmount, requireDeposit } = configInfo;
  const isBetSufficient = Number(betAmount) >= Number(requireBet);
  const isDepositSufficient = Number(depositAmount) >= Number(requireDeposit);
  switch (scope) {
    case "Any":
      return isBetSufficient || isDepositSufficient ? false : "Any";
    case "All":
      return isBetSufficient && isDepositSufficient ? false : "All";
    case "HasDeposit":
      return Number(depositAmount) > 0 ? false : "HasDeposit";
    default:
      return false;
  }
});
</script>

<style scoped lang="scss">
.table-item {
  @apply flex-1 flex-center h-[58px];
}
.table-item-checked {
  @apply text-[11px] text-[#151A1F] flex-center h-[32px] w-[77px] rounded-[16px] bg-[#FFDF12];
}
</style>
